module.exports = __webpack_public_path__ + "img/rateLev_2.64c9b2b0.svg";